import { IconPropsType } from '..';

export const InstagramIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M24.3728 10.4116H15.6284C12.7502 10.4116 10.4121 12.755 10.4121 15.6279V24.3723C10.4121 27.2504 12.7555 29.5886 15.6284 29.5886H24.3728C27.2509 29.5886 29.589 27.2452 29.589 24.3723V15.6279C29.589 12.7498 27.2457 10.4116 24.3728 10.4116ZM19.9953 25.7091C16.8499 25.7091 14.2863 23.1508 14.2863 20.0001C14.2863 16.8494 16.8446 14.291 19.9953 14.291C23.1461 14.291 25.7044 16.8494 25.7044 20.0001C25.7044 23.1508 23.1461 25.7091 19.9953 25.7091ZM26.3282 15.156C25.5052 15.156 24.8446 14.4903 24.8446 13.6724C24.8446 12.8546 25.5104 12.1888 26.3282 12.1888C27.146 12.1888 27.8118 12.8546 27.8118 13.6724C27.8118 14.4903 27.146 15.156 26.3282 15.156Z"
      fill="#961B47"
    />
    <path
      d="M20 0C8.95413 0 0 8.95413 0 20C0 31.0459 8.95413 40 20 40C31.0459 40 40 31.0459 40 20C40 8.95413 31.0459 0 20 0ZM31.2765 24.3722C31.2765 28.1782 28.1783 31.2818 24.367 31.2818H15.6225C11.8165 31.2818 8.71297 28.1835 8.71297 24.3722V15.6278C8.71297 11.8218 11.8113 8.71822 15.6225 8.71822H24.367C28.1783 8.71822 31.2765 11.8165 31.2765 15.6278V24.3722Z"
      fill="#961B47"
    />
    <path
      d="M19.9947 16.021C17.8033 16.021 16.0156 17.8034 16.0156 20C16.0156 22.1966 17.7981 23.9791 19.9947 23.9791C22.1913 23.9791 23.9737 22.1966 23.9737 20C23.9737 17.8034 22.1913 16.021 19.9947 16.021Z"
      fill="#961B47"
    />
  </svg>
);
